import React, { useEffect, useState } from "react";
import WeeklyProgressSection from "../Components/WeeklyProgressSection";
import TaskListSection from "../Components/TaskListSection";
import { navigateWithFai, navigateWithFaiWithOnTap, triggerShare } from "../utils/Utils";
import { lifestyleApi } from "../apiService/api";
import { getUrlParams } from "../apiService/timespam";
import SectionHeader from "../Components/SectionHeader";

const TaskPage = ({ type, shareConfig }) => {
  const [taskData, setTaskData] = useState(null);

  useEffect(() => {
    const { encryptedId } = getUrlParams();

    if (!encryptedId) return;

    lifestyleApi
      .taskDataByType(encryptedId, type)
      .then((response) => {
        if (response?.data?.code === 200) {
          setTaskData(response.data.data);
        } else {
          console.error("Invalid response:", response);
        }
      })
      .catch((err) => console.error("Error loading task data:", err));
  }, [type]);

  // 🔥 SKELETON WHILE LOADING
  if (!taskData) {
    return (
      <div
        style={{
          width: "100%",
          margin: "0 auto",
          backgroundColor: "var(--bg-card)",
          borderRadius: "20px",
          border: "1px solid var(--border-subtle)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px",
          boxSizing: "border-box",
          overflow: "hidden",
        }}>
        {/* Skeleton Weekly Header */}
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "8px 4px",
            boxSizing: "border-box",
            marginBottom: "12px",
          }}>
          <div
            className="shimmer"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
            }}
          />
          <div style={{flex: 1, marginLeft: 10}}>
            <div
              className="shimmer"
              style={{
                width: "60%",
                height: 18,
                borderRadius: 10,
              }}
            />
            <div
              className="shimmer"
              style={{
                width: "40%",
                height: 12,
                marginTop: 6,
                borderRadius: 8,
              }}
            />
          </div>
        </div>

        {/* Skeleton title + View all (qdailyTasks) */}
        {type === "dailyTasks" && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "5px",
              padding: "0 8px",
              boxSizing: "border-box",
            }}>
            <div
              className="shimmer"
              style={{
                width: "40%",
                height: 16,
                borderRadius: 10,
              }}
            />
            <div
              className="shimmer"
              style={{
                width: 70,
                height: 14,
                borderRadius: 10,
              }}
            />
          </div>
        )}

        {/* Skeleton Task Rows */}
        <div
          style={{
            width: "100%",
            marginTop: type === "dailyTasks" ? "16px" : "20px",
            boxSizing: "border-box",
          }}>
          {(type === "dailyTasks"
            ? [1, 2, 3, 4, 5, 6]
            : [1, 2, 3, 4, 5, 6, 7]
          ).map((i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    height: "65px",
                    background: "var(--bg-surface)",
                    borderRadius: "50px",
                    padding: "16px 16px",
                    boxSizing: "border-box",
                    marginBottom: "14px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    gap: "16px",
                  }}>
                  {/* LEFT */}
                  <div
                    style={{
                      paddingLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                      minWidth: 0,
                    }}>
                    <div
                      className="shimmer"
                      style={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                      }}
                    />
                    <div style={{flex: 1, minWidth: 0}}>
                      <div
                        className="shimmer"
                        style={{
                          width: "70%",
                          height: 14,
                          borderRadius: 8,
                          marginBottom: 6,
                        }}
                      />
                      <div
                        className="shimmer"
                        style={{
                          width: "55%",
                          height: 12,
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div
                    style={{
                      paddingRight: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      flexShrink: 0,
                    }}>
                    <div
                      className="shimmer"
                      style={{
                        width: 60,
                        height: 14,
                        borderRadius: 8,
                      }}
                    />
                    <div
                      className="shimmer"
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                </div>
              ))}
        </div>
      </div>
    );
  }

  // ------------ Normal Render (data loaded) -------------
  const top = taskData.cardData[0].data;
  const rows = top.rows;
  const accentColor = top.headerBackgroundColor || "var(--text-secondary)";

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        margin: "0 auto",
        backgroundColor: "var(--bg-card)",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",

        padding: "10px",
        paddingTop: 0,
        boxSizing: "border-box",
        overflow: "hidden"
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: accentColor,
          margin: "0 -10px",
          borderRadius: "20px 20px 0 0",
        }}
      >
        {type === "dailyTasks" && taskData.cardMetaData?.hasViewAll && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: 14,
              transform: "translateY(-50%)",
              padding: "5px 12px",
              backgroundColor: "rgba(255,255,255,0.18)",
              border: "1.5px solid rgba(255,255,255,0.85)",
              borderRadius: "999px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#ffffff",
              cursor: "pointer",
              whiteSpace: "nowrap",
              zIndex: 1
            }}
            onClick={() => {
              navigateWithFaiWithOnTap(taskData.cardMetaData.onTap);
            }}
          >
            {taskData.cardMetaData.viewAllText}
          </div>
        )}

        <SectionHeader
          icon={top.Image}
          title={top.Name}
          subtitle={top.lastActiveValue}
          titleColor="#ffffff"
          subtitleColor="rgba(255,255,255,0.85)"
          showShare={!!shareConfig?.isSharable}
          onShareClick={() => triggerShare(shareConfig?.text)}
        />
      </div>
      {type === "dailyTasks" && taskData.cardMetaData?.title && (
        <div
          style={{
            width: "100%",
            marginTop: "15px",
            padding: "0 8px"
          }}
        >
          <div
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "var(--text-primary)"
            }}
          >
            {taskData.cardMetaData.title}
          </div>
        </div>
      )}

      {/* Task List */}
      <div
        style={{
          width: "100%",

          boxSizing: "border-box"
        }}
      >
        {rows.map((r, i) => (
          <TaskListSection
            key={i}
            icon={r.icon}
            title={r.titleText}
            subTitle={r.subTitleText}
            value={r.value}
            tickIcon={r.tickIcon}
            onClick={() => {
              navigateWithFaiWithOnTap(r.onTap);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default TaskPage;